export const SITE_ID = Number(window.AMZ_ENV?.VITE_SITE_ID ?? 0);
export const SITE_UID = (window.AMZ_ENV?.VITE_SITE_UID ?? "") as string;
export const SUBDOMAIN = (window.AMZ_ENV?.VITE_SUBDOMAIN ?? "") as string;
